<!-- src/components/Home.vue -->

<template>
  <div>
    <header-component />
    <selectDateBanner-component />
    <footer-component />
  </div>
</template>
<script>
import headerComponent from '../header/headerComponent.vue';
import selectDateBannerComponent from '../selectDate/selectDateBannerComponent.vue';
import footerComponent from '../footer/footerComponent.vue';

export default {
  name: 'bookingComponent',
  components: {
    headerComponent,
    selectDateBannerComponent,
    footerComponent,
  },
};
</script>
